module.exports = __webpack_public_path__ + "img/yidaoh5.27f166ac.png";